<template>
  <!-- 工作台 -->
  <div class="page-container home-page-padding split-panel">
    <div class="page-left">
      <div class="card-panel el-card-panel bg-panel top-pannel">
        <el-card
          :class="item.canUse ? 'box-card' : 'box-card-disable'"
          v-for="(item, index) in opList"
          :key="item.id"
          @click.native="getIntoNew(index)"
        >
          <div class="title-text">
            <span>{{ item.zh_name }}</span>
            <span class="font-tip">{{ item.en_name }}</span>
          </div>
          <img
            :src="
              index === 0 ? img_booking : index === 1 ? img_manifest : img_VGM
            "
            alt="暂无图片"
          />
        </el-card>
      </div>
      <el-row class="card-panel el-card-panel bg-panel" >
        <el-col>
          <el-row
            class="panel-top"
            type="flex"

            align="middle"

          >

              <el-input
                class="input-search"
                size="mini"
                placeholder="请输入单个客户业务编号、订单号、提单号进行查询"
                clearable
                v-model="nameComputed"
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i
              ></el-input>
               <el-button
                class="btn-search"
                type="primary"
                size="small"

                @click="getStatus"
                >查询</el-button
              >

            <!-- <el-col :span="2" justify="end">

            </el-col> -->
          </el-row>
          <div
            class="panel-top status-info"
            type="flex"
            justify="start"
            align="middle"
          >
            <div class="status-info-item">
              <p class="title">提单号</p>
              <router-link :class="mblNo ? 'BLN_link' : ''" :to="{name:'ladingbillEdit',params:{ebOrderId: ebOrderId}}"
                >{{ mblNo ? mblNo : "--" }}
              </router-link>
            </div>
            <div class="status-info-item">
              <p class="title">船公司</p>
              {{ carrierName ? carrierName : "--" }}
            </div>
            <div class="status-info-item">
              <p class="title">船名航次</p>
              {{ realVesselNameEn ? realVesselNameEn : "--" }}
            </div>
            <div class="status-info-item">
              <p class="title">客户业务编号</p>
              {{ custBizNo ? custBizNo : "--" }}
            </div>
            <div class="status-info-item" v-if="orderNo !== null">
              <router-link class="BLN_link" :to="{name:'StatusHistory',params:{orderNo: orderNo}}"
              >状态历史
              </router-link>
            </div>
          </div>
          <el-row class="panel-top">
            <!--      状态条 start-->
            <el-scrollbar ref="statusScrollPane" class="tags-view-wrapper">
              <div
                v-for="(item, index) in axisStatusList.slice(0, 4)"
                :key="item.index"
              >
                <div class="node-content">
                  <div class="node-dot"></div>
                  <img
                    :src="item.iconStatus[item.index]"
                    class="node-content-img"
                  />

                  <div
                    v-if="index !== 3"
                    :class="item.index == '0' ? 'solid-style' : 'dashed-style'"
                  ></div>

                  <div class="node-content-name">{{ item.text[0] }}</div>
                  <span class="node-content-date">{{ item.text[1] }}</span>
                </div>
              </div>
              <div class="middle-icon-ship">
                <!-- <img :src="icon_mid_ship" alt="" /> -->
                <svg-icon class="icon-ship" icon-class="ship"></svg-icon>
                <div class="dashed-line"></div>
              </div>
              <!-- 后状态条 -->
              <div
                v-for="(item, index) in axisStatusList.slice(4, 8)"
                :key="item.index"
              >
                <div class="node-content">
                  <div class="node-dot"></div>
                  <img
                    :src="item.iconStatus[item.index]"
                    class="node-content-img"
                  />

                  <div
                    v-if="index !== 3"
                    :class="item.index == '0' ? 'solid-style' : 'dashed-style'"
                  ></div>
                  <div class="node-content-name">{{ item.text[0] }}</div>
                  <span class="node-content-date">{{ item.text[1] }}</span>

                </div>
              </div>
            </el-scrollbar>
            <!--      状态条 end-->
          </el-row>
        </el-col>
      </el-row>
      <div class="card-panel el-card-panel bottom-dev-wrp">
        <el-card class="bottom-card">
          <div class="bottom-card-left">
            <el-row class="bottom-card-item-detail item-top">
              <el-col class="go-text">
                <el-row class="item-left">Freight rate inquiry</el-row>
                <el-row class="item-top">运价查询</el-row>
                <el-row class="item-waiting">敬请期待</el-row>
              </el-col>
            </el-row>
          </div>
          <img :src="img1" alt="暂无图片" />
        </el-card>
        <el-card class="bottom-card">
          <div class="bottom-card-left">
            <el-row class="bottom-card-item-detail item-top">
              <el-col :span="18" class="go-text">
                <el-row class="item-left">Cabin recommendation</el-row>
                <el-row class="item-top">舱位推荐</el-row>
                <el-row class="item-waiting">敬请期待</el-row>
              </el-col>
              <!-- <el-col :span="6" class="go-detail">
                <i class="el-icon-s-unfold"></i>详情
              </el-col> -->
            </el-row>
          </div>
          <img :src="img2" alt="暂无图片" />
        </el-card>
        <el-card class="bottom-card">
          <div class="bottom-card-left">
            <el-row class="bottom-card-item-detail item-top">
              <el-col :span="18" class="go-text">
                <el-row class="item-left">Route recommendation</el-row>
                <el-row class="item-top">航线推荐</el-row>
                <el-row class="item-waiting">敬请期待</el-row>
              </el-col>
              <!-- <el-col :span="6" class="go-detail">
                <i class="el-icon-s-unfold"></i>详情
              </el-col> -->
            </el-row>
          </div>
          <img :src="img3" alt="暂无图片" />
        </el-card>
      </div>
    </div>
    <div class="page-right">
      <ul class="card-panel el-card-panel bg-panel top-panel">
        <li class="li-style li-border flex-position">
          <img class="icon-li-block" :src="icon_ship" />
          <div class="li-title">
            <el-link type="primary" class="li-title-left">船公司消息</el-link>
            <!-- <el-link type="primary" class="see-more">更多</el-link> -->
          </div>
        </li>
        <ul class="ul-style">
          <div v-if="messageList.length > 0" class="message-content">
            <li
              class="li-style"
              v-for="item in messageList"
              :key="item.index"
              @click="popWindow(item, $event)"
            >
              <div class="li-items">
                <i class="li-icon"></i>
                <span class="li-text">{{ item.infoTitle }}</span>
              </div>
              <div class="li-date">{{ item.publishTime }}</div>
            </li>
          </div>
          <div class="icon-wrp" v-else>
            <img class="icon-none-info" :src="icon_none_info" alt="" />
            <div class="txt-none-info">暂无消息</div>
          </div>
        </ul>
      </ul>
      <ul class="card-panel el-card-panel bg-panel top-panel center-panel">
        <li class="li-style li-border flex-position">
          <img class="icon-li-block" :src="icon_news" />
          <div class="li-title">
            <el-link type="primary" class="li-title-left">华贸公共消息</el-link>
            <!-- <el-link type="primary" class="see-more">更多</el-link> -->
          </div>
        </li>
        <ul class="ul-style message-content">
          <li
            class="li-style common-message"
            v-for="(item, index) in recommendationList"
            @click="popWindow(item, $event)"
            :key="item.index"
          >
            <div class="li-items">
              <i :class="index == 0 ? 'li-icon-top' : 'li-icon'"></i>
              <span class="li-text" style="text-indent: 10px">
                {{ item.infoTitle }}</span
              >
            </div>
            <div class="li-date">{{ item.publishTime }}</div>
          </li>
        </ul>
      </ul>
      <!-- Form -->
      <div class="common-message-dialog">
      <el-dialog width="40%" title="详情" :visible.sync="dialogFormVisible">
        <el-row>
          <el-col :span="12" style="font-size:16px;font-weight: 600;">{{ name.infoTitle }}</el-col>
           <el-col :span="12"><div style="float:right">{{ name.publishTime }}</div></el-col>
        </el-row>
        <el-row style="margin-top:10px">{{name.infoContent}}</el-row>
<!--         <el-form :model="name">
          <el-col>
            <el-row :gutter="10" type="flex" justify="center">
              <el-col :span="10">
                <el-form-item label="标题">
                  <el-input
                    v-model="name.infoTitle"
                    autocomplete="off"
                    size="mini"
                    case="upper"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="发布时间">
                  <el-input
                    v-model="name.publishTime"
                    autocomplete="off"
                    size="mini"
                    case="upper"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" type="flex" justify="center">
              <el-col :span="18">
                <el-form-item label="正文:">
                  <el-input
                    size="mini"
                    type="textarea"
                    case="upper"
                    disabled
                    v-model="name.infoContent"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-form> -->
<!--         <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogFormVisible = false"
            >确 定</el-button
          >
        </div> -->
      </el-dialog>
      </div>
      <!-- 下载文件区域 -->
      <ul
        class="
          card-panel
          el-card-panel
          bg-panel
          top-panel
          bottom-panel
          right-card
        "
      >
        <li class="li-style li-border flex-position">
          <img class="icon-li-block" :src="icon_downlaod" />
          <div class="li-title">
            <el-link type="primary" class="li-title-left">下载文件区域</el-link>
            <!-- <el-link type="primary" class="see-more">更多</el-link> -->
          </div>
        </li>
        <div
          class="li-items message-content"
          style="margin: 10px 0"
          v-for="item in downloadFileList"
          :key="item.id"
        >
          <img
            class="icon-file"
            :src="item.icon == 'icon_xlsx' ? icon_xlxs : icon_pdf"
            alt=""
          />
          <a class="a-file" :href="item.file" :download="item.file_name">{{
            item.name
          }}</a>
          <img class="icon-download2" :src="icon_downlaod2" alt="" />
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
import { getOpList } from "@/api/test";
import ScrollPane from "@/layout/components/TagsView/ScrollPane";
import { queryMdInfo } from "@/api/queryMainSystem";
import { getEbOrder } from "@/api/ebOrder";
import { querySpOrderStatus,querySpOrderStatusByGoOrderId } from "@/api/status";

export default {
  name: "Dashboard",
  components: { ScrollPane },
  data() {
    return {
      name: {
        infoTitle: "",
        publishTime: "",
        infoContent: "",
      },
      dialogFormVisible: false,
      formLabelWidth: "120px",
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },
      mblNo: null,
      carrierName: null,
      custBizNo: null,
      realVesselNameEn: null,
      show: false,
      ebOrderId: null,
      orderNo: null,
      no: "",
      opList: [
        {
          id:1,
          zh_name: "我要订舱",
          en_name: "RESERVATION",
          canUse: true,
        },
        {
           id:2,
          zh_name: "发送舱单",
          en_name: "SEND MANIFEST",
          canUse: true,
        },
        {
              id:3,
          zh_name: "发送VGM",
          en_name: "SEND VGM",
          canUse: true,
        },
      ],
      completeStatus: 0,
      img_booking: require("../../assets/images/dashboard_imgs/one.png"),
      img_manifest: require("../../assets/images/dashboard_imgs/two.png"),
      img_VGM: require("../../assets/images/dashboard_imgs/three.png"),
      img_start: require("../../assets/images/dashboard_imgs/start.png"),
      img_end: require("../../assets/images/dashboard_imgs/end.png"),
      img_arrow: require("../../assets/images/dashboard_imgs/arrow.png"),
      img1: require("../../assets/images/dashboard_imgs/1.png"),
      img2: require("../../assets/images/dashboard_imgs/2.png"),
      img3: require("../../assets/images/dashboard_imgs/3.png"),
      messageList: [],
      recommendationList: [],
      icon1: require("@/assets/img/status/status1.png"),
      icon2: require("@/assets/img/status/status2.png"),
      icon3: require("@/assets/img/status/status3.png"),
      icon4: require("@/assets/img/status/status4.png"),
      icon5: require("@/assets/img/status/status5.png"),
      icon6: require("@/assets/img/status/status6.png"),
      icon7: require("@/assets/img/status/status7.png"),
      icon8: require("@/assets/img/status/status8.png"),
      icon9: require("@/assets/img/status/status9.png"),
      icon_mid_ship: require("@/assets/images/dashboard_imgs/icon_mid_ship.png"),
      icon_ship: require("@/assets/images/dashboard_imgs/ship.png"),
      icon_news: require("@/assets/images/dashboard_imgs/news.png"),
      icon_downlaod: require("@/assets/images/dashboard_imgs/download.png"),
      icon_downlaod2: require("@/assets/images/dashboard_imgs/download2.png"),
      icon_none_info: require("@/assets/images/dashboard_imgs/none-info.png"),
      icon_pdf: require("@/assets/images/dashboard_imgs/pdf.png"),
      icon_xlxs: require("@/assets/images/dashboard_imgs/xlxs.png"),
      icon_word: require("@/assets/images/dashboard_imgs/word.png"),
      downloadFileList: [
        {
          id: 0,
          icon: "icon_xlsx",
          file_name: "舱单导入模板.xlsx",
          name: "舱单导入模板",
          file: "./downloads/BK.xlsx"
        },
        {
          id: 1,
          icon: "icon_xlsx",
          file_name: "MBL箱货导入模板.xlsx",
          name: "MBL箱货导入模板",
          file: "./downloads/MBL.xlsx"
        }
      ],
      axisStatusList: [
        {
          index: "0",
          text: ["装船", null],
          iconStatus: {
            0: require("@/assets/img/status/status6.png"),
            2: require("@/assets/img/status/status4.png"),
          },
        },
        {
          index: "0",
          text: ["放行", null],
          iconStatus: {
            0: require("@/assets/img/status/status7.png"),
            2: require("@/assets/img/status/status3.png"),
          },
        },
        {
          index: "0",
          text: ["空箱出场", null],
          iconStatus: {
            0: require("@/assets/img/status/status9.png"),
            2: require("@/assets/img/status/status1.png"),
          },
        },
        {
          index: "0",
          text: ["重箱进场", null],
          iconStatus: {
            0: require("@/assets/img/status/status8.png"),
            2: require("@/assets/img/status/status2.png"),
          },
        },
        {
          index: "0",
          text: ["抵港", null],
          iconStatus: {
            0: require("@/assets/img/status/status9.png"),
            2: require("@/assets/img/status/status5.png"),
          },
        },
        {
          index: "0",
          text: ["清关", null],
          iconStatus: {
            0: require("@/assets/img/status/status9.png"),
            2: require("@/assets/img/status/status5.png"),
          },
        },
        {
          index: "0",
          text: ["重箱离场", null],
          iconStatus: {
            0: require("@/assets/img/status/status9.png"),
            2: require("@/assets/img/status/status5.png"),
          },
        },
        {
          index: "0",
          text: ["空箱进场", null],
          iconStatus: {
            0: require("@/assets/img/status/status9.png"),
            2: require("@/assets/img/status/status5.png"),
          },
        },
      ],
    };
  },
  created() {},
  computed: {
    nameComputed: {
      get: function () {
        return this.no;
      },
      set: function (val) {
        this.no = val.toUpperCase();
      },
    },
  },
  mounted() {
    // this.getOpList();
    this.getMessageList();
    this.getRecommendationList();
    this.getMenu();
  },
  methods: {
    popWindow(item, $event) {
      let self = this;
      self.name.infoTitle = item.infoTitle;
      self.name.publishTime = item.publishTime;
      self.name.infoContent = item.infoContent;
      self.dialogFormVisible = true;
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    querySpOrderStatus(id) {
      let self = this;
      let data = {
        goOrderId: id,
      };
      querySpOrderStatusByGoOrderId(data)
        .then((res) => {
          if (res.success) {
            console.log(res);
            self.show = true;
            let newAxisStatusList = self.axisStatusList;
            res.records.node.forEach((item, index) => {
              newAxisStatusList[index]["index"] = item["index"];
              newAxisStatusList[index]["text"] = item["text"];
            });
            self.axisStatusList = newAxisStatusList;
          } else {
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getMenu() {
      let self = this;
      self.$store.dispatch("user/getMenu").then((res) => {
        console.log(self.$store.state.user.rightRouters);
      });
    },
    getOpList() {
      let _this = this;
      getOpList().then((res) => {
        if (res.code === 20000) {
          _this.opList = res.data.data;
        } else {
        }
      });
    },
    getMessageList() {
      let _this = this;
      queryMdInfo({ infoType: "NS" }).then((res) => {
        res.forEach((item) => {
          if (item.publishTime) {
            let day = item.publishTime.split("T")[0];
            let time = item.publishTime.split("T")[1].split("Z")[0];
            item.publishTime = day + " " + time;
            item.timeStamp = new Date(item.publishTime).getTime();
          }
          res.sort(function (a, b) {
            return b.timeStamp - a.timeStamp;
          });
        });

        _this.messageList = res;
        console.log("船公司消息：", res);
      });
    },
    getRecommendationList() {
      let _this = this;
      queryMdInfo({ infoType: "NT" }).then((res) => {
        res.forEach((item) => {
          if (item.publishTime) {
            let day = item.publishTime.split("T")[0];
            let time = item.publishTime.split("T")[1].split("Z")[0];
            item.publishTime = day;
            item.timeStamp = new Date(item.publishTime).getTime();
          }
          res.sort(function (a, b) {
            return b.timeStamp - a.timeStamp;
          });
        });

        _this.recommendationList = res;
      });
    },
    // 进入新增
    getIntoNew(index) {
      if (index === 0) {
        // 进入订舱
        this.$router.push({
          path: "/booking/Add",
          params: {
            type: "add",
          },
        });
      } else if (index === 1) {
        // this.$message({
        //   type: "info",
        //   message: "暂未开放，敬请期待",
        // });

        // 发送舱单
        this.$router.push({
          name: "manifestAdd",
        });
      } else {
        // 发送VGM
        // this.$message({
        //   type: "info",
        //   message: "暂未开放，敬请期待",
        // });

        this.$router.push({
          name: "VGMAdd",
        });
      }
    },
    getStatus() {
      let self = this;
      if (self.no.trim().length === 0) {
        self.$coreMethods.message(
            "warning",
            "请输入单个客户业务编号、订单号、提单号进行查询"
        );
      } else {
        let searchData = {
          arrayNo: self.no,
        };
        getEbOrder(searchData).then((res) => {
          if (res.success) {
            if(res.data.length>0){
              self.orderNo = res.data[0].orderNo;
              self.mblNo = res.data[0].mblNo;
              self.carrierName = res.data[0].carrierName;
              self.custBizNo = res.data[0].custBizNo;
              self.realVesselNameEn = res.data[0].realVesselNameEn;
              self.ebOrderId = res.data[0].ebOrderId;
              self.querySpOrderStatus(res.data[0].goOrderId);
              // self.$router.push({
              //   name: "StatusHistory",
              //   params: {
              //     orderNo: self.orderNo
              //     // carrierName: self.carrierName,
              //     // mblNo: self.mblNo,
              //     // custBizNo: self.custBizNo,
              //   },
              // });
            }
          }
        });
      }
    }
  },
};
</script>

<style scoped lang="scss">
.split-panel {
  background: #f4f6fa;
  // height: 100%;
  // height: 100%;
  width: 100%;

  .page-left {
    width: 75%;

    .card-panel {
      display: flex;
      background-color: #fff;
      justify-content: space-around;
      align-items: center;
      width: 100%;
      // margin-left: 10px;
      border-radius: 10px;
      .box-card {
        width: 32%;
        height: 120px;
        // margin-right: 10px;
        display: flex;
        transition: all 0.5s;
        padding: 0 10px;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        background: linear-gradient(
          0deg,
          rgba(255, 255, 255, 1) 0%,
          rgba(228, 241, 255, 0.9) 100%
        );
        background-blend-mode: normal;
        box-shadow: 0px 2px 15px rgba(188, 198, 209, 0.24);
        border-radius: 10px;

        img {
          height: 80px;
          margin-left: 30px;
          background-size: 100% 100%;
        }

        .title-text {
          // width: calc(100% - 80px);
          display: flex;
          flex-flow: column;
          // font-weight: 500;
          font-size: 20px;
          line-height: 18px;
          color: #3f3f3f;
          font-weight: normal;
          //  margin-bottom: 20px;
          .font-tip {
            color: #929292;
            font-size: 13.5px;
            font-weight: normal;
            margin-top: 10px;
          }
        }
      }
      .box-card:hover {
        //  transition: background 1.3s;

        background: linear-gradient(
          0,
          rgba(235, 250, 255, 1) 0%,
          rgba(204, 228, 255, 1) 100%
        );
      }
      .box-card-disable {
        width: 32%;
        height: 120px;
        // margin-right: 10px;
        display: flex;
        transition: all 0.5s;
        padding: 0 10px;
        justify-content: center;
        align-items: center;
        // cursor: pointer;
        background: linear-gradient(
          0deg,
          rgba(255, 255, 255, 1) 0%,
          rgba(228, 241, 255, 1) 100%
        );
        background-blend-mode: normal;
        box-shadow: 0px 2px 15px rgba(188, 198, 209, 0.24);
        border-radius: 10px;
        opacity: 0.6;

        img {
          height: 80px;
          margin-left: 30px;
          background-size: 100% 100%;
        }

        .title-text {
          // width: calc(100% - 80px);
          display: flex;
          flex-flow: column;
          // font-weight: 500;
          font-size: 20px;
          line-height: 18px;
          color: #3f3f3f;
          font-weight: normal;
          //  margin-bottom: 20px;
          .font-tip {
            color: #929292;
            font-size: 13.5px;
            font-weight: normal;
            margin-top: 10px;
          }
        }
      }
    }

    .recommendation-panel:not(:first-child) {
      margin-top: 10px;
    }

    .second-row {
      background-color: #4ab4fe;
      color: #ffffff;
      height: 30px;
      padding: 0px 8px;
    }

    .row-panel {
      background-color: #ffffff;
      border-bottom: 1px solid #eeee;
      height: 40px;
      line-height: 25px;
    }

    .row-panel:last-child {
      border-bottom: none;
    }
  }
  //右侧面板
  .page-right {
   width: 25%;
    margin-left: 16px;
    margin-right: 5px;
    .top-panel {
      height: 230px;
      // position: absolute;
    }

    .icon-wrp {
      .icon-none-info {
        width: 100px;
        height: 100px;
        margin: 10px auto;
      }
    }
    .icon-li-block {
      width: 14px;
      height: 14px;
      // margin-right: 5px;
    }
    .page-right-icon {
      width: 10px;
      height: 10px;
    }
  }
}

.el-scrollbar ::v-deep .el-scrollbar__wrap {
  height: 182px;

  .el-scrollbar__view {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 0;
    .node-content {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      color: #595959;
      margin-top: 60px;

      width: 100px;
      z-index: 999;
      .node-dot {
        width: 14px;
        height: 14px;
        border: 1.5px solid rgba(0, 145, 255, 1);
        position: absolute;
        border-radius: 8px;
        background-color: #fff;
        z-index: 9999;
        top: -45px;
      }
      .node-content-img {
        width: 35px;
        background-size: 100% 100%;
        margin-bottom: 10px;
      }

      .solid-style {
        height: 5px;

        background-color: rgba(224, 232, 243, 1);
        width: 95px;
        position: absolute;
        top: -40px;
        left: 52px;
      }

      .dashed-style {
        height: 5px;

        background-color: rgba(224, 232, 243, 1);
        width: 95px;
        position: absolute;
        top: -40px;
        left: 52px;
      }
      // .dashed-style::before {
      //   content: "o";
      //   font-size: 24px;
      //   color: rgba(0, 145, 255, 1);
      //   position: absolute;
      //   background-color: #fff;
      //   top: -15px;
      //   left: -10px;
      // }

      .node-content-name {
        margin-top: 4px;
        font-size: 13px;

      }

      .node-content-date {
        font-size: 12px;
        margin-top: 4px;
        width: 80px;
        text-align: center;
        white-space: pre-wrap;
      }
    }
  }
}

.status-info {
  background-color: #4b96fd;
  color: #ffffff;
  font-size: 14px;
  height: 75px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 0px 20px;
  border-radius: 10px;
  margin: 20px 0;
  .status-info-item {
    margin: 0 30px;
    // display: flex;
    // flex-direction: column;
    // align-items: center;
    // justify-content: start;
    // height: 100%;
    // margin-top: 20px;
    .title {
      margin: 5px;
      padding: 0;
    }
  }
}

.BLN_link {
  border-bottom: 1.5px solid #ffffff;
}

.bottom-card {
  width: 31%;
  height: 192px;
  background: rgba(244, 246, 250, 1);
  display: flex;
  border: none;
  margin: 20px 5px;
  justify-content: space-between;
  padding: 20px;
  box-sizing: border-box;
  img {
    width: 111px;
    height: 102px;
    margin-left: 20px;
  }

  .item-top {
    // margin-top: 5px;
    // padding: 0 5px;
  }

  .bottom-card-item-detail {
    font-size: 12px;
    width: 100%;

    .go-text {
      .item-left {
        margin-top: -10px;
        // width: 90%;
        white-space: nowrap;
        color: rgba(99, 99, 99, 0.5);
        font-size: 16px;
        width: 130px;
      }
      .item-top {
        margin: 10px 0;
        white-space: nowrap;
        color: rgba(99, 99, 99, 1);
        font-size: 20px;
      }
      .item-waiting {
        font-size: 16px;
        white-space: nowrap;
        margin-top: 30px;
        color: #63636350;
      }
    }

    .go-detail {
      color: #4ab4fe;
      text-align: right;
    }
  }
}

.li-style {
  // border-bottom: 1px solid #eeeeee;
  margin-top: 2px;
  margin-bottom: 6px;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #595959;
  padding-bottom: 10px;
  box-sizing: border-box;

  .li-title {
    border: none;
  }
  .li-title-left {
    color: #2d2d31;
  }
}
.see-more {
  font-size: 12px !important;
}
.li-items {
  // padding: 3px 5px;
  border-radius: 10px;
  display: flex;
  box-sizing: border-box;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}
.icon-file {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}
.a-file {
  display: flex;
  font-size: 14px;
  display: flex;
  justify-content: start;
  align-items: center;
  color: #595959;
  padding-bottom: 10px;
  box-sizing: border-box;
  width: 70%;
  margin-top: 10px;
}
.icon-download2 {
  margin-left: auto;
  width: 16px;
  height: 16px;
}
.li-text {
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 150px;
  overflow: hidden;
}

.li-date {
  // flex: 2;
  width: 50%;
  white-space: nowrap;
  display: flex;
  color: #b0b0b0;
  font-size: 12px;
  align-items: center;
  justify-content: end;
}

.bottom-dev-wrp {
  // margin-top: 55px;
  // width:90%;
  margin-left: 10px;
  margin-right: 10px;
}
.btn-search {
  border: 1px solid rgba(75, 150, 253, 1) !important;
  border-radius: 5px !important;
  // position: absolute;;
  // right: 0;
}
.btn-search:hover {
  background-color: rgba(75, 150, 253, 1) !important;
}
.top-pannel {
  background-color: #ffffff00 !important;
  padding: 0 !important;
  display: flex;
  justify-content: space-between !important;
}

</style>
